// Mapper: transport LC_TodayEmployeeStatusItemOut → domain row for the "Mi equipo" dashboard
// "Situación de asistencia" employee status table (ASIS-5408 / REXASIS-007). No business rules
// computed here — the backend already resolves the status label/priority; this only reshapes
// the wire item into the row shape the `Table` component expects (`id` + renamed `rut`).

import type {
  LC_TodayEmployeeStatusItemOut,
  MyTeamTodayEmployeeStatusRow,
} from '../types/myTeamTodayEmployeeStatus.types';


export function mapMyTeamTodayEmployeeStatusItem(
  out: LC_TodayEmployeeStatusItemOut,
): MyTeamTodayEmployeeStatusRow {
  return {
    id: out.employeeId,
    rut: out.employeeTaxIdentificationNumber,
    employeeName: out.employeeName,
    statusCode: out.statusCode,
    status: out.status,
    entryTime: out.entryTime,
    entryModality: out.entryModality,
    exitTime: out.exitTime,
    exitModality: out.exitModality,
    lateSummary: out.lateSummary,
    overtimeHours: out.overtimeHours,
  };
}
